import React from 'react';
import { Box, Card, Grid, Heading } from '@tq/ui-components';

import { COLOURS } from '@tq/ui-components/dist/pp2/theme';

export type CardLayoutProps = {
  heading: string;
  [key: string]: unknown;
};

export const CardLayout: React.FC<CardLayoutProps> = ({ heading, children, ...rest }) => {
  return (
    <Card>
      <Grid>
        <Heading
          size='sm'
          p={4}
          borderBottom={`1px solid ${COLOURS.gray['300']}`}
          backgroundColor={COLOURS.gray[100]}
        >
          {heading}
        </Heading>
        <Box p={4} {...rest}>
          {children}
        </Box>
      </Grid>
    </Card>
  );
};
